import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, Grid } from '@mui/material';
import { Card, Button, CollapseCard } from '@totalsoft/rocket-ui';
import CharismaExposureComponent from './CharismaExposureComponent';
import WebExposureComponent from './WebExposureComponent';
import DynamicExposureComponent from './DynamicExposureComponent';
import { RightsContext } from 'providers/RightsContext';
import CurrencySelectorComponent from './CurrencySelector/CurrencySelectorComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';

const ExposureCard = ({ t, exposure, onCompute, computing, onCurrencyChange, selectedCurrency }) => {
  const { isImage, readOnlyFull, folderComputeExposure } = useContext(RightsContext);

  return (
    <Card title={t('Document.Exposure.Title')}>
      {exposure.loading ? (
        <WrappedFakeText lines={20} />
      ) : exposure.loaded ? (
        <Box display='flex' flexDirection='column' gap={1}>
          <CollapseCard
            defaultExpanded={true}
            title={
              <span style={{ fontSize: 'medium' }}>
                <strong>{t('Document.Exposure.Charisma.Title')}</strong>
              </span>
            }
            content={
              <CharismaExposureComponent exposure={exposure.existingExposure} currencyValue={selectedCurrency?.exchangeRateValue ?? 1} />
            }
          />
          <CollapseCard
            defaultExpanded={true}
            title={
              <span style={{ fontSize: 'medium' }}>
                <strong> {t('Document.Exposure.Web.Title')}</strong>
              </span>
            }
            content={<WebExposureComponent exposure={exposure.newExposure} currencyValue={selectedCurrency?.exchangeRateValue ?? 1} />}
          />
          <CollapseCard
            defaultExpanded={true}
            title={
              <span style={{ fontSize: 'medium' }}>
                <strong> {t('Document.Exposure.Summary')}</strong>
              </span>
            }
            content={
              <DynamicExposureComponent
                dynamicFields={exposure.exposureDynamicFields}
                currencyValue={selectedCurrency?.exchangeRateValue ?? 1}
              />
            }
          />
        </Box>
      ) : (
        ''
      )}
      <Grid item container justifyContent={'space-between'} alignItems={'flex-end'}>
        {!isImage && (
          <Button onClick={onCompute} disabled={computing || readOnlyFull || !folderComputeExposure}>
            {computing ? t('Computing') : t('Compute')}
          </Button>
        )}
        {exposure.exposureCurrencies && (
          <CurrencySelectorComponent
            exposureCurrencies={exposure.exposureCurrencies}
            selectedCurrency={selectedCurrency}
            onCurrencyChange={onCurrencyChange}
          />
        )}
      </Grid>
    </Card>
  );
};

ExposureCard.propTypes = {
  t: PropTypes.func.isRequired,
  exposure: PropTypes.object.isRequired,
  onCompute: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  computing: PropTypes.bool.isRequired,
  selectedCurrency: PropTypes.object
};

export default withTranslation()(ExposureCard);
